import React from 'react';
import { times as _times } from 'lodash-es';
import './SummeryLoader.scss';

const SummeryLoader = ({ size, dataSectionCount, showGrid, dataSectionHeight, noMinHeight, showGridTable }) => {
  // --- render data section items
  const renderDataItems = () => {
    const count = dataSectionCount || 3;
    const sectionHeight = `${dataSectionHeight || 140}px`;
    let loader_item = [];
    _times(count, i => {
      loader_item?.push(<div className='loader_item' style={{ minHeight: sectionHeight }} key={i} />);
    });
    return loader_item;
  };

  return (
    <>
      <div className={`c-loader ${size ? size : ''} ${noMinHeight ? 'noMinHeight' : ''}`}>
        <div
          className={`loader_sections ${showGrid ? '' : 'noGrid'} ${size ? size : ''} ${
            showGrid && showGridTable ? 'grid-2' : ''
          }`}
        >
          {renderDataItems()}
        </div>
      </div>
    </>
  );
};

export default SummeryLoader;
